import { apiClient } from "../config";

async function exportChat(id: number) {
  const res = await apiClient.get(`/admin/conversations/${id}/export`);
  return res.data;
}

export default exportChat;
